var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import BusinessGoodsPriceService from '../../api/BusinessGoodsPriceService';
import Header from "./components/Header.vue";
import { Loading } from 'element-ui';
import _ from 'lodash';
import Add from './Add';
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from '../../helper/UrlWrapper';
import { toDetail } from '../../helper/util';
import ApplyClientsDialog from './components/NewApplyClientsDialog';
import ImportFileDialog from './components/ImportFileDialog';
import SetEndTimeDialog from './components/SetEndTimeDialog';
import CommonService from "../../api/CommonService";
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurchaseList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    PurchaseList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    PurchaseList.prototype.getList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign({}, this.filter, pager, {
            sort_field: this.order ? this.order[0] : null,
            sort_type: this.order ? this.order[1] : null,
        });
        this.service.getList(params).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
            if (params.keyword_type == '1') {
                window._czc.push(["_trackEvent", '销售价格搜索类型', '销售价格搜索类型', '按客户名称搜索']);
            }
            else {
                window._czc.push(["_trackEvent", '销售价格搜索类型', '销售价格搜索类型', '按单号搜索']);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseList.prototype.audit = function (row) {
        var _this = this;
        this.$confirm("是否要审核？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_id: row.order_id
            };
            _this.service.audit(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("审核成功");
                _this.getList();
                window._czc.push(["_trackEvent", '销售价格审核', '销售价格审核']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.discard = function (row) {
        var _this = this;
        this.$confirm("是否要废弃？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_id: row.order_id
            };
            _this.service.discard(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("废弃成功");
                _this.getList();
                window._czc.push(["_trackEvent", '销售价格废弃', '销售价格废弃']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.stop = function (row) {
        var _this = this;
        this.$confirm("是否要停用？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_id: row.order_id
            };
            _this.service.stop(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("停用成功");
                _this.getList();
                window._czc.push(["_trackEvent", '销售价格停用', '销售价格停用']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.start = function (row) {
        var _this = this;
        this.$confirm("是否确认启用？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_id: row.order_id
            };
            _this.service.start(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg || res.data.message);
                _this.getList();
                window._czc.push(["_trackEvent", '销售价格启用', '销售价格启用']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.copy = function (row) {
        this.addTab({
            component: Add,
            title: '复制销售价格单',
            showExist: true,
            name: 'businessgoodsprice_copy' + row.order_id,
            cprops: {
                orderid: row.order_id,
                pageuse: 'copy'
            }
        });
    };
    PurchaseList.prototype.applyClients = function (row) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: row.order_id
        };
        this.service.getBusiness(params).then(function (res1) {
            loadingInstance.close();
            var tmpRow = res1.data.data;
            if (tmpRow.shop_ids) {
                tmpRow.shop_ids.forEach(function (shop) {
                    tmpRow.supplier_to_business_ids.push(shop.shop_id + '_' + shop.supplier_to_business_id + '_' + shop.business_id);
                });
            }
            var dialog = _this.$dialog(ApplyClientsDialog, {
                data: {
                    supplier_to_business_ids: tmpRow.supplier_to_business_ids || [],
                    group_ids: tmpRow.group_ids || [],
                    disabled: !(_this.Root_PageAuth.Modify && (row.order_status == 1 || row.order_status == 2)),
                    shop_ids: tmpRow.shop_ids || [],
                    business_ids: tmpRow.business_ids || [],
                },
                showEmpty: true
            }, {
                title: "设置客户",
                width: 640,
                height: 530,
            });
            dialog.instance.$on("submit", function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                var params = {
                    order_id: row.order_id,
                    business_info: JSON.stringify(res.business_info)
                };
                _this.service.setBusiness(params).then(function (res) {
                    loadingInstance.close();
                    _this.$message.success("设置客户成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '销售价格设置客户', '销售价格设置客户']);
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.msg || err.message);
                });
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.setEndTime = function (row) {
        var _this = this;
        var dialog = this.$dialog(SetEndTimeDialog, {
            data: {
                es_time: row.es_time,
                ee_time: row.ee_time
            }
        }, {
            title: "设置价格执行区间",
            width: 600,
            height: 420
        });
        dialog.instance.$on("submit", function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_id: row.order_id,
                ee_time: res.ee_time
            };
            _this.service.delayEeTime(params).then(function (res) {
                loadingInstance.close();
                dialog.instance.close();
                _this.$message.success("设置价格执行区间成功");
                _this.getList();
                window._czc.push(["_trackEvent", '销售价格设置价格执行区间', '销售价格设置价格执行区间']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        });
    };
    PurchaseList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurchaseList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加销售价格单',
            showExist: true,
            name: 'businessgoodsprice_add',
            cprops: {}
        });
    };
    PurchaseList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '编辑销售价格单',
            showExist: true,
            name: 'businessgoodsprice_edit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
    };
    PurchaseList.prototype.lookDetail = function (row) {
        toDetail(EBillType.BusinessGoodsPrice, row.order_id, this);
    };
    PurchaseList.prototype.importFile = function (row) {
        this.$refs.importFileDg.open();
    };
    PurchaseList.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        var url = "supplierclientapi/businessgoodsprice/export?order_id=" + orderIds.join(",");
        url = UrlHelper.addParam(url, "token", this.user.token);
        var params = _.cloneDeep(this.$refs.listHeader.formData);
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop || !order) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurchaseList = __decorate([
        Component({
            components: {
                'list-header': Header,
                'import-file-dialog': ImportFileDialog
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
